/** Free user limits — replaces Demo Mode. */
import { FREE_USER_FEE_COPY, PLUS_UPSELL_COPY } from './productCopy';

export const MAX_FREE_FRIENDS = 3;

export const FREE_TIER_MESSAGE = FREE_USER_FEE_COPY;

export const PLUS_UPSELL_MESSAGE = PLUS_UPSELL_COPY;

export const FREE_FRIEND_LIMIT_MESSAGE =
  `Free accounts can add up to ${MAX_FREE_FRIENDS} friends. LockedIn Plus unlocks unlimited friends and private chat.`;

export const FREE_PRIVATE_CHAT_MESSAGE =
  'Private chat requires LockedIn Plus. Subscription payments do not add wallet funds.';

export const SUBSCRIPTION_ONLY_MESSAGE =
  'This feature requires LockedIn Plus. Wallet funds are separate from subscriptions.';

export function canAddFreeFriend(currentFriendCount) {
  return currentFriendCount < MAX_FREE_FRIENDS;
}

export function countUserAddedFriends(friends) {
  return (friends || []).filter((f) => f.id !== 'admin-morpheus').length;
}
